import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';

interface GetQuantifyDenominatorWhereClauseOptions {
  shouldIncludeDashboardFilters?: boolean;
}

export const useGetQuantifyDenominatorWhereClause = ({
  shouldIncludeDashboardFilters = true,
}: GetQuantifyDenominatorWhereClauseOptions = {}) => {
  return useQuantifyStore(({ query, visual }) => {
    return shouldIncludeDashboardFilters
      ? visual.quantifyAndDashboardFilters.denominatorWhereClause ??
          query.formulaQuery?.denominatorWhereClause
      : query.formulaQuery?.denominatorWhereClause;
  });
};
